import styled from 'styled-components';

export const FaqSectionContainer = styled.div`
    font-size: 14px;
    cursor: default;

    svg {
        float: right;
        margin-right: 10px;
        height: auto;
        color: ${props => props.theme.lightGrey};
    }

    .question {
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        font-size: 14px;
        font-weight: ${props => props.theme.boldWeight};
        padding: 30px 0 5px 0;

        .svg-fleche path {
            fill: ${props => props.theme.arrowSvgColor};
        }

        &.open {
            font-weight: ${props => props.theme.boldWeight};
        }
    }

    .question-comment-ca-marche-page {
        cursor: pointer;

        svg {
            position: absolute;
            top: 0;
            right: 0;
        }
    }

    .answer {
        &.noListMarker {
            ul {
                list-style-type: inherit;
            }
        }

        p {
            padding: 10px 0 0;
        }
    }

    &:first-of-type .question {
        padding-top: 0;
    }

    &:last-child {
        margin: 0 0 23px;
    }

    a {
        color: ${props => props.theme.faqLinkTextColor};
    }

    &:not(:last-child):after {
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        margin: 23px auto 0;
        background: ${props => props.theme.faqBorderColor};
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/faq/FaqElementComponentStyle.js